import country_en from './country/en'
import country_no from './country/no'

export default {
    en: country_en,
    no: country_no
}
